module.exports = __webpack_public_path__ + "img/48.1.1c927dd8.jpg";